import { EThemeType } from "redux/reducers";

interface Props {
  isHomeActive?: boolean;
  theme?: EThemeType;
}
export const Home = ({isHomeActive, theme}:Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="15"
      viewBox="0 0 16 15"
      fill="none"
    >
      <g clipPath="url(#clip0_2276_3391)">
        <path
          d="M15.9944 7.48611C15.9944 7.98611 15.5778 8.37777 15.1056 8.37777H14.2167L14.2361 12.8278C14.2361 12.9028 14.2306 12.9778 14.2222 13.0528V13.5028C14.2222 14.1167 13.725 14.6139 13.1111 14.6139H12.6667C12.6361 14.6139 12.6056 14.6139 12.575 14.6111C12.5361 14.6139 12.4972 14.6139 12.4583 14.6139L11.5556 14.6111H10.8889C10.275 14.6111 9.77778 14.1139 9.77778 13.5V12.8333V11.0556C9.77778 10.5639 9.38056 10.1667 8.88889 10.1667H7.11111C6.61944 10.1667 6.22222 10.5639 6.22222 11.0556V12.8333V13.5C6.22222 14.1139 5.725 14.6111 5.11111 14.6111H4.44444H3.55833C3.51667 14.6111 3.475 14.6083 3.43333 14.6056C3.4 14.6083 3.36667 14.6111 3.33333 14.6111H2.88889C2.275 14.6111 1.77778 14.1139 1.77778 13.5V10.3889C1.77778 10.3639 1.77778 10.3361 1.78056 10.3111V8.375H0.891667C0.391667 8.375 0.00277805 7.98611 0.00277805 7.48333C0.00277805 7.23333 0.0861114 7.01111 0.280556 6.81666L7.4 0.611108C7.59444 0.416663 7.81667 0.388885 8.01111 0.388885C8.20556 0.388885 8.42778 0.444441 8.59444 0.58333L15.6889 6.81944C15.9111 7.01389 16.0222 7.23611 15.9944 7.48611Z"
          // fill="#4338CA"
          fill={isHomeActive && theme=== 'light'? "#4338CA": isHomeActive && theme=== 'dark'? "#527AE6":"#94A3B8"}
        />
      </g>
      <defs>
        <clipPath id="clip0_2276_3391">
          <rect
            width="16"
            height="14.2222"
            fill="white"
            transform="translate(0 0.388885)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
